import { render } from "./GameResultsView.vue?vue&type=template&id=6a08228b"
import script from "./GameResultsView.vue?vue&type=script&lang=js"
export * from "./GameResultsView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/webovi/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__